import { render, staticRenderFns } from "./mailSettingList.vue?vue&type=template&id=e5392954&scoped=true&"
import script from "./mailSettingList.vue?vue&type=script&lang=js&"
export * from "./mailSettingList.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingList.vue?vue&type=style&index=0&id=e5392954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5392954",
  null
  
)

export default component.exports